import React, { useEffect } from "react";

function importAll(r) {
  let images = {};
  r.keys().forEach((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}
const businessImageList = importAll(
  require.context("../images/businesses", false, /\.(png|jpe?g|svg)$/)
);
const collegesImageList = importAll(
  require.context("../images/colleges", false, /\.(png|jpe?g|svg)$/)
);

const MayHaveSeenUsOn = () => {
  return (
    <div className="bg-primary flex flex-col items-center ">
      <div class="w-full inline-flex max-w-screen-2xl  flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
        <ul
          id="logos"
          class="flex w-max no-wrap items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll-backward"
        >
          {Object.values(collegesImageList).map((img) => (
            <li key={img} class="h-auto w-[150px]   sm:w-[150px] rounded-lg">
              <img class="w-full" src={img} alt="" />
            </li>
          ))}
          {Object.values(collegesImageList).map((img) => (
            <li key={img} class="h-auto w-[150px]   sm:w-[150px] rounded-lg">
              <img class="w-full" src={img} alt="" />
            </li>
          ))}
        </ul>
      </div>
      <div class="w-full inline-flex max-w-screen-2xl flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
        <ul
          id="logos"
          class="flex w-max no-wrap items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll-forward"
        >
          {Object.values(businessImageList).map((img) => (
            <li key={img} class="h-auto w-[150px]   sm:w-[150px] rounded-lg">
              <img class="w-full" src={img} alt="" />
            </li>
          ))}
          {Object.values(businessImageList).map((img) => (
            <li key={img} class="h-auto w-[150px]   sm:w-[150px] rounded-lg">
              <img class="w-full" src={img} alt="" />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MayHaveSeenUsOn;

//  <div className=" py-8 flex justify-center  max-w-screen-2xl mx-auto items-center text-3xl sm:text-5xl xl:text-6xl font-bold">
//         <h1>Who We've Worked With:</h1>
//       </div>
//       <div className="flex flex-col justify-center">
//         <div class="flex p-3 flex-wrap justify-center">
//           {Object.values(collegesImageList).map((img) => (
//             <div class="h-auto w-[50px]   sm:w-[80px] rounded-lg">
//               <img class="w-full" src={img} alt="" />
//             </div>
//           ))}
//         </div>
//         <div class="flex p-3 flex-wrap justify-center">
//           {Object.values(businessImageList).map((img) => (
//             <div class="h-auto w-[50px]   sm:w-[80px] rounded-lg">
//               <img class="w-full" src={img} alt="" />
//             </div>
//           ))}
//         </div>
//       </div>
